var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};
function formatState (state) {
	if (!state.id) {
    	return state.text;
  	}
	var flagUrl = state.title;
	var $state = $(
  	'<span class="dropdown-image"><img src="' + flagUrl + '" class="img-flag" /> </span><span class="dropdown-text">' + state.text + '</span>'
	);
	return $state;
};
jQuery(document).ready(function(){
	waitForEl('.bold_option.bold_option_swatch label input[type="checkbox"]', function() {
		$(".bold_option.bold_option_swatch").each(function(index, ele){
			var customOptions = '';
			var getFirstTitle = $.trim($(this).find(".bold_option_title").text());
			$(this).find(".bold_option_value").each(function(index, value){
				if(index == 0)
				{
					var getCheckboxValue = $(this).find('input[type="checkbox"]').val();
					var getCheckboxImage = $(this).find('.bold_option_value_swatch span').attr("style");
					getCheckboxImage = getCheckboxImage.replace('background-image: url("', '');
					getCheckboxImage = getCheckboxImage.replace('");', '');
					customOptions += '<option value="placeholder" title="'+getCheckboxImage+'">'+getFirstTitle+'</option>';
				}
			});
			$(this).find(".bold_option_value").each(function(){
				var getCheckboxPrice = $.trim($(this).find('.bold_option_value_price span').text());
				var getCheckboxValue = $(this).find('input[type="checkbox"]').val();
				var getCheckboxImage = $(this).find('.bold_option_value_swatch span').attr("style");
				getCheckboxImage = getCheckboxImage.replace('background-image: url("', '');
				getCheckboxImage = getCheckboxImage.replace('");', '');
				if(typeof getCheckboxPrice != "undefined" && getCheckboxPrice != null && getCheckboxPrice != "")
				{
					customOptions += '<option value="'+getCheckboxValue+'" title="'+getCheckboxImage+'">'+getCheckboxValue+' ('+getCheckboxPrice+')</option>';
				}
				else
				{
					customOptions += '<option value="'+getCheckboxValue+'" title="'+getCheckboxImage+'">'+getCheckboxValue+'</option>';
				}
			});
			if(typeof customOptions != "undefined" && customOptions != null && customOptions != "")
			{
				var customSelectHtml = '';
				customSelectHtml = '<select name="custom-bold-swatch-lists" class="custom-bold-swatch-lists">'+customOptions+'</select>';
				$(this).append(customSelectHtml);
				$(".custom-bold-swatch-lists").select2({
		      	templateResult: formatState,
		      	templateSelection: formatState,
		      	minimumResultsForSearch: -1,
		      	disableSearch: true,
		      	multiple: true,
		      	dropdownAutoWidth: true,
		      	width: '100%',
						height: '30px',
		      	dropdownParent: $(this)
		    });
		  }
		});
		$(".custom-bold-swatch-lists").on('select2:select', function(e) {
			var customSelectValue = $(this).val();
			var selectedValueId = e.params.data.id;
			var customSelectedOption = [];
			if(selectedValueId == "placeholder")
			{
				$(this).val(["placeholder"]).trigger("change");
			}
			else
			{
				$(customSelectValue).each(function(index, value){
					if(typeof value != "undefined" && value != null && value != "")
					{
						if(value != "placeholder")
						{
							customSelectedOption.push(value);
						}
					}
				});
				if($(customSelectedOption).length > 0)
				{
					$(this).val(customSelectedOption).trigger("change");
				}
				else
				{
					$(this).val(["placeholder"]).trigger("change");
				}
			}
			$(this).parent().find(".bold_option_element .bold_option_value").each(function(){
          var currentCheckBoxValue = $(this).find('input[type="checkbox"]').attr("value");
          if(jQuery.inArray(currentCheckBoxValue, customSelectedOption) !== -1)
          {
              $(this).find(".bold_option_value_element").addClass("bold_swatch_selected");
              if($(this).find('input[type="checkbox"]').prop("checked") == false)
              {
                  $(this).find('input[type="checkbox"]').trigger("click");
              }
              $(this).find('input[type="checkbox"]').prop("checked", true);
          }
          else
          {
              $(this).find(".bold_option_value_element").removeClass("bold_swatch_selected");
              if($(this).find('input[type="checkbox"]').prop("checked") == true)
              {
                  $(this).find('input[type="checkbox"]').trigger("click");
              }
              $(this).find('input[type="checkbox"]').prop("checked", false);
          }
      });
		});
		$(".custom-bold-swatch-lists").on('select2:unselect', function(e) {
			var customSelectValue = $(this).val();
			var customSelectedOption = [];
			$(customSelectValue).each(function(index, value){
				if(typeof value != "undefined" && value != null && value != "")
				{
					if(value != "placeholder")
					{
						customSelectedOption.push(value);
					}
				}
			});
			if($(customSelectedOption).length > 0)
			{
				$(this).val(customSelectedOption).trigger("change");
			}
			else
			{
				$(this).val(["placeholder"]).trigger("change");
			}
			$(this).parent().find(".bold_option_element .bold_option_value").each(function(){
          var currentCheckBoxValue = $(this).find('input[type="checkbox"]').attr("value");
          if(jQuery.inArray(currentCheckBoxValue, customSelectedOption) !== -1)
          {
              $(this).find(".bold_option_value_element").addClass("bold_swatch_selected");
              if($(this).find('input[type="checkbox"]').prop("checked") == false)
              {
                  $(this).find('input[type="checkbox"]').trigger("click");
              }
              $(this).find('input[type="checkbox"]').prop("checked", true);
          }
          else
          {
              $(this).find(".bold_option_value_element").removeClass("bold_swatch_selected");
              if($(this).find('input[type="checkbox"]').prop("checked") == true)
              {
                  $(this).find('input[type="checkbox"]').trigger("click");
              }
              $(this).find('input[type="checkbox"]').prop("checked", false);
          }
      });
		});
	});
});